import { isNil } from 'lodash';
import * as orderProjectService from 'services/orderProjectService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWROrderProjectsData = Awaited<
  ReturnType<typeof orderProjectService.getOrderProjectsAsync>
>;

const useOrderProjects = (
  orderId: number,
  load = true
): SWRResponse<SWROrderProjectsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_PROJECTS_ENDPOINT, orderId] : null,
    async ([_, params]) => await orderProjectService.getOrderProjectsAsync(params)
  );

export const SWR_ORDER_PROJECTS_ENDPOINT = 'order-projects';
export default useOrderProjects;
